import { render, staticRenderFns } from "./NLSDashboardPage.vue?vue&type=template&id=aa80281c&scoped=true"
import script from "./NLSDashboardPage.vue?vue&type=script&lang=js"
export * from "./NLSDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./NLSDashboardPage.vue?vue&type=style&index=0&id=aa80281c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa80281c",
  null
  
)

export default component.exports